import { takeEvery, fork, put, all, call } from "redux-saga/effects";

//Account Redux states
import { REGISTER_USER } from "./actionTypes";
import { registerUserSuccessful, registerUserFailed } from "./actions";
import { APIClient } from "../../../helpers/api_helper";
import i18n from "../../../i18n";

const api = new APIClient();

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user, history } }) {
  try {
    const urlRegister = history.location.pathname.includes("/sign-up")
      ? `${process.env.REACT_APP_API_BASE_URL}/api/onboarding/verify/token/${user.token}`
      : `${process.env.REACT_APP_API_BASE_URL}/api/tenant/child/verify/token/${user.token}`;

    const register = () =>
      api.create(urlRegister, {
        token: user.token,
        emailAddress: user.emailAddress,
        password: user.password,
      });
    const response = yield call(register);

    if (response.valid) {
      yield put(
        registerUserSuccessful({
          user: {
            email: user.emailAddress,
            confirm_password: user.password,
            rememberMe: user.rememberMe,
          },
        })
      );
    } else {
      yield put(
        registerUserFailed(response.error || i18n.t("auth.signUp.failed"))
      );
    }
  } catch (error) {
    // Handle Axios error
    let errorMessage = i18n.t("auth.signUp.unexpectedError");
    console.log(error, "> error");
    console.log(error.response, "> error.response");
    if (error && error.data) {
      errorMessage = error.data.error || JSON.stringify(error.data);
    } else if (error.message) {
      errorMessage = error.message;
    }

    yield put(registerUserFailed(errorMessage));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
